export const DEFAULT_LANDSCAPE_AR = 16 / 9;
export const DEFAULT_PORTRAIT_AR = 3 / 4;
export const PAGINATION_HEIGHT = 56;
export const TILE_GAP = 4;
